module.exports = __webpack_public_path__ + "img/maestro.fb1c0652.svg";